// extracted by mini-css-extract-plugin
export var headerCell = "_72-1";
export var loadingSpinnerContainer = "_72-4";
export var loadingStateCell = "_72-5";
export var rowWrapper = "_72-3";
export var standaloneTable = "_72-6";
export var table = "_72-0";
export var white = "_72-2";